const AllRoutes = {
  HOME: "/",
};

export default AllRoutes;